// removed by extract-text-webpack-plugin
module.exports = {"Network":"src-components-WhatAboutCollege-Network----Network-module---Network---9a7w5","Network__Wrapper":"src-components-WhatAboutCollege-Network----Network-module---Network__Wrapper---2kD44","Logos":"src-components-WhatAboutCollege-Network----Network-module---Logos---3eNph","Logo":"src-components-WhatAboutCollege-Network----Network-module---Logo---ZkVVJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/WhatAboutCollege/Network/Network.module.scss
// module id = 749
// module chunks = 275037778433214